const CompanyFilter = ({ companies, selected, onChange }) => {
  return (
    <div data-testid="company-filter" className="flex gap-2">
      <button
        data-testid="company-filter-all"
        onClick={() => onChange(null)}
        className={`px-4 py-2 font-body text-sm uppercase tracking-widest transition-colors border ${
          !selected ? 'bg-maroon text-white border-maroon' : 'bg-transparent text-text-secondary border-border hover:border-maroon hover:text-maroon'
        }`}
      >
        All
      </button>
      {companies.map((company) => (
        <button
          key={company.id}
          data-testid={`company-filter-${company.name.toLowerCase()}`}
          onClick={() => onChange(company.id)}
          className={`px-4 py-2 font-body text-sm uppercase tracking-widest transition-colors border ${
            selected === company.id ? 'bg-maroon text-white border-maroon' : 'bg-transparent text-text-secondary border-border hover:border-maroon hover:text-maroon'
          }`}
        >
          {company.name}
        </button>
      ))}
    </div>
  );
};

export default CompanyFilter;
